/*
 * Copyright (c) 2026.
 * Spin in het Web B.V. Apeldoorn.
 * Deze software mag alleen gebruikt / bekeken / gewijzigd worden volgens de voorwaarden die zijn vastgelegd in een bijbehorende schriftelijke overeenkomst met Spin in het Web B.V.
 */

/**
 * Auteur: Jelmer Jellema - Spin in het Web B.V
 * Gegenereerd met Claude Code (AI), 19-08-2026
 *
 * Vertaalt de speciale namen (voorvoegsel `___`, zoals `___qszero`) naar hun leesbare variant.
 * Gedeeld door de labelweergave en het normfout-overzicht; gewone namen blijven ongewijzigd.
 */
import type {TranslateService} from '@ngx-translate/core';

export function specialenaam(naam: string, translateService: TranslateService): string {
    return naam?.slice(0, 3) === '___' ? translateService.instant(`SPECIALENAMEN.${naam}`) : naam;
}
